/*
 * @Author: ken yang
 * @Date: 2022-09-07 09:21:36
 * @LastEditTime: 2023-06-06 16:32:00
 * @LastEditors: ken yang
 * @Description: map的store
 * @FilePath: /uexch_pc/src/store/map.js
 */
import { defineStore } from 'pinia'
import { nextTick } from 'vue'

const useMapStore = defineStore('mapStore', {
  state: () => {
    return {
      _areaList: {},
    }
  },
  getters: {
    areaList: (state) => {
      return state._areaList
    },
  },
  actions: {
    async BaseAreaList (type) {
      const data = await userApi.areaList({ type })
      this.$patch(state => {
        state._areaList[type] = data.map(e => ({ label: e.nationalityName, value: e.phoneAreaCode, icon: e.icon }))
      })
    },
    async getAreaList () {
      this.BaseAreaList(0) // 注册
      this.BaseAreaList(1) // 实名
      this.BaseAreaList(2) // 登录
    }
  },
  init () {
    this.getAreaList()
  },
})

export default useMapStore
